import $ from "jquery";

// La liste des ressources humaines (shared/_staffs) utilise des rangées en
// div (.staffs-row) plutôt qu'un tableau : même geste, mêmes classes.
const removeTableRow = () => {
  $("tbody, .staffs-list").on("click", ".remove-table-row", function (event) {
    $(this).closest("tr, .staffs-row").remove();
    return event.preventDefault();
  });
};

export { removeTableRow };
